export const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_FAIL    = "ORDER_LIST_FAIL";
export const ORDER_LIST_UPDATE    = "ORDER_LIST_UPDATE";